import { request } from "./request";

//图片上传
export function uploadApi(formdata) {
  return request({
    url: "/api/login/uploadImg",
    upload: true,
    data: formdata,
  });
}
//注册
export function registeredApi(formdata) {
  return request({
    url: "/api/login/register",
    data: formdata,
  });
}
//获取验证码
export function getYzmApi(email) {
  return request({
    url: "/api/login/sendMsg",
    data: {
      email,
    },
  });
}
//忘记密码
export function forgetPassApi(formdata) {
  return request({
    url: "/api/login/forget",
    data: formdata,
  });
}
//获取用户协议
export function getUserAgreeApi() {
  return request({
    url: "/api/login/getXieyi",
  });
}
//登录
export function loginApi(formdata) {
  return request({
    url: "/api/login/login",
    data: formdata,
  });
}
//商品列表
export function goodslistApi(formdata) {
  return request({
    url: "/api/order/GoodsList",
    data: formdata,
  });
}
//立即购买
export function buyApi(formdata) {
  return request({
    url: "/api/order/buy",
    data: formdata,
  });
}
//充值
export function payApi(formdata) {
  return request({
    url: "/api/order/recharge",
    data: formdata,
  });
}
//购买订单列表
export function buyListApi(formdata) {
  return request({
    url: "/api/order/buyList",
    data: formdata,
  });
}
//充值记录
export function payListApi(formdata) {
  return request({
    url: "/api/order/rechargeList",
    data: formdata,
  });
}
//轮询订单支付结果
export function resultApi(formdata) {
  return request({
    url: "/api/order/queryOrder",
    data: formdata,
  });
}
//添加或修改企业信息
export function addOrDelQyApi(formdata) {
  return request({
    url: "/api/user/addGroupInfo",
    data: formdata,
  });
}
//获取行业分类
export function getHyApi(token) {
  return request({
    url: "/api/user/getGroupType",
    data: {
      token,
    },
  });
}
//获取企业信息
export function getQyApi(token) {
  return request({
    url: "/api/user/getGroupInfo",
    data: {
      token,
    },
  });
}
//获取个人信息
export function getMselfApi(token) {
  return request({
    url: "/api/user/getUserInfo",
    data: {
      token,
    },
  });
}
//修改姓名
export function editNameApi(formdata) {
  return request({
    url: "/api/user/editName",
    data: formdata,
  });
}
//修改手机号
export function editPhoneApi(formdata) {
  return request({
    url: "/api/user/editPhone",
    data: formdata,
  });
}
//修改密码
export function editPassApi(formdata) {
  return request({
    url: "/api/user/editPwd",
    data: formdata,
  });
}
//修改姓名邮箱
export function editEmailApi(formdata) {
  return request({
    url: "/api/user/editEmail",
    data: formdata,
  });
}
//获取充值提示
export function getTipApi() {
  return request({
    url: "/api/login/getRecharge",
  });
}
